import { render, staticRenderFns } from "./AddDoctorCommision.vue?vue&type=template&id=a2057f94"
import script from "./AddDoctorCommision.vue?vue&type=script&lang=js"
export * from "./AddDoctorCommision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports